export default "__VITE_ASSET__DCPRYe5X__"